import {
    SET_KPI_EVALUATION_REQUEST,
    SET_KPI_EVALUATION_SUCCESS,
    SET_KPI_EVALUATION_ERROR,
} from "./../../constants/kpiSummaryDashboardEnhancement/kpiSummaryLevelThreeConstants";

const iState = {
    loading: false,
};

export default (state= iState, action) => {
    switch(action.type) {
        case SET_KPI_EVALUATION_REQUEST:
            return{
                loading: true,
                kpiStatusData: {},
                error: ""
            };
        case SET_KPI_EVALUATION_SUCCESS:
            return{
                loading: false,
                kpiStatusData: action.successKpiData,
                error: ""
            };
        case SET_KPI_EVALUATION_ERROR:
            return{
                loading: false,
                kpiStatusData: {},
                error: action.payload
            };
        default:
            return state;
    }
};